var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-fab',_vm._g({staticClass:"fab is-primary",attrs:{"actions":_vm.actionsWithTooltip,"bg-color":"#7957d5"}},_vm.on))}
var staticRenderFns = []

export { render, staticRenderFns }